/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Automatic_Save_Restore_Point_FailedInputs */

const en_automatic_save_restore_point_failed = /** @type {(inputs: Automatic_Save_Restore_Point_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to create a restore point. ${i?.message}`)
};

const fr_automatic_save_restore_point_failed = /** @type {(inputs: Automatic_Save_Restore_Point_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la création d’un point de restauration. ${i?.message}`)
};

const de_automatic_save_restore_point_failed = /** @type {(inputs: Automatic_Save_Restore_Point_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Es konnte kein Wiederherstellungspunkt erstellt werden. ${i?.message}`)
};

const it_automatic_save_restore_point_failed = /** @type {(inputs: Automatic_Save_Restore_Point_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile creare un punto di ripristino. ${i?.message}`)
};

const ru_automatic_save_restore_point_failed = /** @type {(inputs: Automatic_Save_Restore_Point_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось создать точку восстановления. ${i?.message}`)
};

const es_automatic_save_restore_point_failed = /** @type {(inputs: Automatic_Save_Restore_Point_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo crear un punto de restauración. ${i?.message}`)
};

const zh_cn2_automatic_save_restore_point_failed = /** @type {(inputs: Automatic_Save_Restore_Point_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`创建还原点失败。${i?.message}`)
};

const ja_automatic_save_restore_point_failed = /** @type {(inputs: Automatic_Save_Restore_Point_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`復元ポイントの作成に失敗しました。${i?.message}`)
};

const hi_automatic_save_restore_point_failed = /** @type {(inputs: Automatic_Save_Restore_Point_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पुनर्स्थापना बिंदु बनाने में विफल। ${i?.message}`)
};

const pt_pt2_automatic_save_restore_point_failed = /** @type {(inputs: Automatic_Save_Restore_Point_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao criar um ponto de restauração. ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to create a restore point. {message}" |
*
* @param {Automatic_Save_Restore_Point_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_restore_point_failed = /** @type {((inputs: Automatic_Save_Restore_Point_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Restore_Point_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_restore_point_failed(inputs)
	if (locale === "de") return de_automatic_save_restore_point_failed(inputs)
	if (locale === "it") return it_automatic_save_restore_point_failed(inputs)
	if (locale === "ru") return ru_automatic_save_restore_point_failed(inputs)
	if (locale === "es") return es_automatic_save_restore_point_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_restore_point_failed(inputs)
	if (locale === "ja") return ja_automatic_save_restore_point_failed(inputs)
	if (locale === "hi") return hi_automatic_save_restore_point_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_restore_point_failed(inputs)
	return en_automatic_save_restore_point_failed(inputs)
});